import { render, staticRenderFns } from "./bookstoreDetail.vue?vue&type=template&id=c2cdcac4&scoped=true&"
import script from "./bookstoreDetail.vue?vue&type=script&lang=js&"
export * from "./bookstoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookstoreDetail.vue?vue&type=style&index=0&id=c2cdcac4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cdcac4",
  null
  
)

export default component.exports